export const SET_CUSTOM_ATTRIBUTES = 'SET_CUSTOM_ATTRIBUTES';
export const GET_CUSTOM_ATTRIBUTES = 'GET_CUSTOM_ATTRIBUTES';
export const ADD_CUSTOM_ATTRIBUTE = 'ADD_CUSTOM_ATTRIBUTE';
export const EDIT_CUSTOM_ATTRIBUTE = 'EDIT_CUSTOM_ATTRIBUTE';
export const DELETE_CUSTOM_ATTRIBUTE = 'DELETE_CUSTOM_ATTRIBUTE';
export const SET_CUSTOM_ATTRIBUTE_TO_EDIT = 'SET_CUSTOM_ATTRIBUTE_TO_EDIT';
